<div *ngIf="!loading">
  <mat-card *ngFor="let message of messages" style="margin-bottom: 16px;" 
      [style.background-color]="isCurrentUserAuthorOfMessage(message) ? '' : '#efffc3'"
      [style.margin-left]="isCurrentUserAuthorOfMessage(message) ? '32px' : ''"
      [style.margin-right]="isCurrentUserAuthorOfMessage(message) ? '' : '32px'">
    <mat-card-header>
      <mat-card-subtitle class="mat-subtitle-2">
        <b style="text-overflow: ellipsis;">{{getMessageAuthor(message)}}</b>
        <span [style.font-weight]="message.unread ? 'bold' : 'normal'" style="text-wrap: nowrap">
           {{getHumanReadableMessageTimestamp(message.createdTime)}}
        </span>
      </mat-card-subtitle>
    </mat-card-header>
    <mat-card-content>
      {{message.message}}
    </mat-card-content>
  </mat-card>
  <form #messageFormComponent="ngForm" (ngSubmit)="sendMessage()" [formGroup]="messageForm">
    <mat-form-field style="width: 100%;">
      <textarea matInput #newMessageTextInput="matInput" formControlName="message" rows="5"></textarea>
      <mat-hint align="end">{{messageForm.controls['message'].value?.length || 0}} / 1000</mat-hint>
      <mat-error *ngIf="messageForm.controls['message'].errors?.['maxlength']" i18n>Message should be maximum 1000 characters long</mat-error>
    </mat-form-field>
    
    <div class="button-panel">
      <button 
            mat-raised-button 
            type="submit"
            color="accent" 
            angulartics2On="click" 
            angularticsAction="SendMessageClick"
            [angularticsCategory]="'' + chatId">
            
          <mat-icon fontSet="material-symbols-outlined">send</mat-icon>
          <ng-container i18n>SEND</ng-container>
      </button>
    </div>
  </form>
</div>
